import { account } from "./account.de";
import { actions } from "./actions.de";
import { addStep } from "./cart.de";
import { checkout } from "./checkout.de";
import { cms } from "./cms.de";
import { cookies } from "./cookies.de";
import { discount } from "./discount.de";
import { errorPage } from "./error-page.de";
import { footer } from "./footer";
import { forms } from "./forms.de";
import { login } from "./login.de";
import { notifications } from "./notifications.de";
import { orderDetails } from "./order-details.de";
import { orderListElement, orderList } from "./orderlist-element.de";
import { printmode } from "./printmode.de";
import { processingSteps } from "./processing-steps.de";
import { register } from "./register.de";
import { repairAnalysisInfo } from "./repairAnalysisInfo.de";
import { welcomeJomatik } from "./welcome-jomatik.de";

export const de = {
  account,
  actions,
  addStep,
  checkout,
  cms,
  cookies,
  discount,
  errorPage,
  footer,
  forms,
  login,
  notifications,
  orderDetails,
  orderList,
  orderListElement,
  printMode: printmode,
  processingSteps,
  register,
  repairAnalysisInfo,
  welcomeJomatik,
};
